import script from "./SchneeflockenComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SchneeflockenComponent.vue?vue&type=script&setup=true&lang=js"

import "./SchneeflockenComponent.vue?vue&type=style&index=0&id=38f92a8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f92a8d"]])

export default __exports__